import {combineReducers} from 'redux';

import originInvoice from './origin-invoice';
import createOriginInvoice from './create-origin-invoice';

export const invoiceReducer = combineReducers({
    originInvoice,
    createOriginInvoice,
});